import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./styles/global.scss";
import * as errorMonitoring from "@/utils/error-monitoring";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "@/components/ErrorFallback";
import { ThemeProvider } from "@/contexts/ThemeProvider";
import { ServiceProvider } from "@/contexts/ServiceProvider";
import { getService } from "@/utils/get-service";
import { BraintreeProvider } from "@/contexts/BraintreeProvider";
import { ValidationControlProvider } from "@/contexts/ValidationControlProvider";
import { ErrorProcessingProvider } from "@/contexts/ErrorProcessingProvider";

errorMonitoring.init();

const service = getService();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary fallback={ErrorFallback}>
      <ServiceProvider service={service}>
        <BraintreeProvider>
          <ThemeProvider>
            <ValidationControlProvider enabled>
              <ErrorProcessingProvider>
                <App />
              </ErrorProcessingProvider>
            </ValidationControlProvider>
          </ThemeProvider>
        </BraintreeProvider>
      </ServiceProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
